var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{attrs:{"height":"100%"}},[_c('Toolbar',{attrs:{"toolbarTitle":_vm.$t('Zertifikatsmanager'),"tooltipMessage":_vm.$t('Hier können Sie Zertifikate andere Nutzer herunterladen und die Abgaben betrachten')}}),_c('v-container',[_c('v-row',[_c('v-col',[_c('Certificates')],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }